var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus44(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98618",
    "data-name": "Group 98618",
    transform: "translate(-212 -553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_910",
    "data-name": "Ellipse 910",
    transform: "translate(212 553)",
    fill: "#fff",
    stroke: "#e2e2f8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "fast-delivery",
    d: "M20.386.168C22.865.744,23.814,2.194,25,4.189H20.386ZM5.9,4.356a.736.736,0,0,1,.838.782.838.838,0,0,1-.835.838H.838a.838.838,0,1,0,0,1.676h7.54a.838.838,0,1,1,0,1.676H.838A.838.838,0,0,0,.838,11H2.681v2.513a.838.838,0,0,0,.838.838H5.2a3.212,3.212,0,0,0,6.294,0H20a3.212,3.212,0,0,0,6.294,0h1.461a.838.838,0,0,0,.838-.838V8.49C28.6,6.031,26,5.868,26,5.864H19.548a.838.838,0,0,1-.838-.838V0H3.519a.838.838,0,0,0-.838.838V2.681H1.676a.838.838,0,1,0,0,1.676Zm18.34,8.269a1.536,1.536,0,1,1-2.622,1.086A1.536,1.536,0,0,1,24.237,12.626Zm-14.8,0a1.536,1.536,0,1,1-2.622,1.086A1.536,1.536,0,0,1,9.436,12.626Zm0,0",
    transform: "translate(218.702 565.539)",
    fill: "#e2e2f8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus44);
export default __webpack_public_path__ + "static/media/status44.ff84fe59363fdffe3b927101186b4ddd.svg";
export { ForwardRef as ReactComponent };